import { render } from "./CoverTags.vue?vue&type=template&id=460f005a&scoped=true"
import script from "./CoverTags.vue?vue&type=script&lang=js"
export * from "./CoverTags.vue?vue&type=script&lang=js"

import "./CoverTags.vue?vue&type=style&index=0&id=460f005a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460f005a"]])

export default __exports__